/* Collection browsing: contextual sheen/thickness and mixed panel categories. */
(function () {
  function initCollectionSheenFilter() {
    document.querySelectorAll('[data-fx-collection-sheen]').forEach(function (filter) {
      if (filter.dataset.fxSheenReady) return;
      filter.dataset.fxSheenReady = 'true';
      var cards = document.querySelectorAll('.fx-contextual-collection .trans-product[data-fx-sheens]');
      if (!cards.length) return;
      filter.querySelectorAll('[data-fx-sheen-filter]').forEach(function (button) {
        button.addEventListener('click', function () {
          var chosen = button.dataset.fxSheenFilter;
          filter.querySelectorAll('[data-fx-sheen-filter]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          document.dispatchEvent(new CustomEvent('fx:collection-sheen-change', { detail: { value: chosen } }));
          cards.forEach(function (card) {
            var sheens = (card.dataset.fxSheens || '').split(',').map(function (value) { return value.trim(); });
            var thicknessButton = document.querySelector('[data-fx-collection-attribute-filter] .is-active');
            var chosenThickness = thicknessButton ? thicknessButton.dataset.fxAttributeFilter : 'all';
            var thickness = (card.dataset.fxThickness || '').trim();
            card.hidden = (chosen !== 'all' && sheens.indexOf(chosen) === -1) || (chosenThickness !== 'all' && thickness !== chosenThickness);
          });
        });
      });
    });
  }

  function initCollectionAttributeFilters() {
    document.querySelectorAll('[data-fx-collection-attribute-filter]').forEach(function (filter) {
      if (filter.dataset.fxAttributeReady) return;
      filter.dataset.fxAttributeReady = 'true';
      var cards = document.querySelectorAll('.fx-contextual-collection .trans-product[data-fx-thickness]');
      filter.querySelectorAll('[data-fx-attribute-filter]').forEach(function (button) {
        button.addEventListener('click', function () {
          var chosen = button.dataset.fxAttributeFilter;
          filter.querySelectorAll('[data-fx-attribute-filter]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          var sheenButton = document.querySelector('[data-fx-collection-sheen] .is-active');
          var chosenSheen = sheenButton ? sheenButton.dataset.fxSheenFilter : 'all';
          cards.forEach(function (card) {
            var thickness = (card.dataset.fxThickness || '').trim();
            var sheens = (card.dataset.fxSheens || '').split(',').map(function (value) { return value.trim(); });
            card.hidden = (chosen !== 'all' && thickness !== chosen) || (chosenSheen !== 'all' && sheens.indexOf(chosenSheen) === -1);
          });
        });
      });
    });
  }

  function initMixedCollectionFilters() {
    document.querySelectorAll('[data-fx-mixed-filters]').forEach(function (filter) {
      if (filter.dataset.fxMixedReady) return;
      filter.dataset.fxMixedReady = 'true';
      var cards = document.querySelectorAll('.fx-mixed-collection .trans-product[data-fx-mixed-category]');
      filter.querySelectorAll('[data-fx-mixed-filter]').forEach(function (button) {
        button.addEventListener('click', function () {
          var chosen = button.dataset.fxMixedFilter;
          filter.querySelectorAll('[data-fx-mixed-filter]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          cards.forEach(function (card) {
            card.hidden = chosen !== 'all' && card.dataset.fxMixedCategory !== chosen;
          });
        });
      });
    });
  }

  function initAllPanelsFilters() {
    var page = document.querySelector('.fx-mixed-collection');
    if (!page || page.dataset.fxAllPanelsReady) return;
    page.dataset.fxAllPanelsReady = 'true';

    var cards = page.querySelectorAll('.trans-product[data-fx-panel-families]');
    if (!cards.length) return;
    var requestedFamily = new URLSearchParams(window.location.search).get('filter');
    var supportedFamilies = ['all', 'spc', 'shower-sets', 'pvc', 'uv', 'book', 'wood-acoustic', 'specialty', 'trims'];
    var state = { family: supportedFamilies.indexOf(requestedFamily) !== -1 ? requestedFamily : 'spc' };
    var title = page.querySelector('[data-fx-panel-title]');
    var stickyTitle = document.querySelector('[data-fx-panel-title-sticky]');
    var reset = page.querySelector('[data-fx-panel-reset]');
    var labels = {
      all: 'All Panels', spc: 'SPC Panels', pvc: 'PVC Panels — 8mm', uv: 'UV Marble Panels',
      book: 'Continuous Book-Match Panels', 'wood-acoustic': 'Wood, Fluted & Acoustic', specialty: 'Specialty Panels', 'shower-sets': 'Shower Kits', trims: 'Trims & Accessories'
    };
    var updateTitle = function () {
      var value = labels[state.family] || 'All Panels';
      if (title) title.textContent = value;
      if (stickyTitle) stickyTitle.textContent = value;
    };
    var syncButtons = function () {
      document.querySelectorAll('[data-fx-panel-filter]').forEach(function (button) {
        var active = button.dataset.fxPanelFilter === state.family;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };
    var apply = function () {
      var visible = 0;
      cards.forEach(function (card) {
        var families = (card.dataset.fxPanelFamilies || '').split('|');
        var matchesFamily = state.family === 'all' || families.indexOf(state.family) !== -1;
        var show = matchesFamily;
        card.hidden = !show;
        if (show) visible += 1;
      });
      var empty = page.querySelector('[data-fx-panel-no-results]');
      if (empty) empty.hidden = visible !== 0;
      if (reset) reset.hidden = state.family === 'all';
      page.classList.toggle('fx-continuous-pattern-grid', state.family === 'book');
      page.classList.toggle('fx-shower-kit-grid', state.family === 'shower-sets');
      syncButtons();
      updateTitle();
    };
    document.querySelectorAll('[data-fx-panel-filter]').forEach(function (button) {
      button.addEventListener('click', function () { state.family = button.dataset.fxPanelFilter; apply(); });
    });
    if (reset) {
      reset.addEventListener('click', function () { state.family = 'all'; apply(); });
    }
    apply();
  }

  function initAccessoriesFilters() {
    var page = document.querySelector('.fx-accessories-collection');
    if (!page || page.dataset.fxAccessoriesReady) return;
    page.dataset.fxAccessoriesReady = 'true';
    var cards = page.querySelectorAll('.trans-product[data-fx-accessory-thickness]');
    if (!cards.length) return;
    var title = page.querySelector('[data-fx-accessories-title]');
    var stickyTitle = document.querySelector('[data-fx-accessories-title-sticky]');
    var requestedFilter = new URLSearchParams(window.location.search).get('filter');
    var state = ['4mm', '8mm', 'led-8mm'].indexOf(requestedFilter) !== -1 ? requestedFilter : 'all';
    var intro = page.querySelector('[data-fx-accessories-title-value]');
    var baseTitle = (intro && intro.dataset.fxAccessoriesTitleValue) || 'Trims & Accessories';
    var apply = function () {
      var visible = 0;
      cards.forEach(function (card) {
        var thicknesses = (card.dataset.fxAccessoryThickness || '').split('|');
        var show = state === 'all' || thicknesses.indexOf(state) !== -1;
        card.hidden = !show;
        if (show) visible += 1;
      });
      document.querySelectorAll('[data-fx-accessories-filter]').forEach(function (button) {
        var active = button.dataset.fxAccessoriesFilter === state;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var empty = page.querySelector('[data-fx-accessories-no-results]');
      if (empty) empty.hidden = visible !== 0;
      if (title) title.textContent = baseTitle;
      if (stickyTitle) stickyTitle.textContent = baseTitle;
    };
    document.querySelectorAll('[data-fx-accessories-filter]').forEach(function (button) {
      button.addEventListener('click', function () { state = button.dataset.fxAccessoriesFilter; apply(); });
    });
    apply();
  }

  function initDealsFilters() {
    var page = document.querySelector('.fx-deals-collection');
    if (!page || page.dataset.fxDealsReady) return;
    page.dataset.fxDealsReady = 'true';
    var cards = page.querySelectorAll('.trans-product[data-fx-deal-category]');
    var sync = function (value) {
      document.querySelectorAll('[data-fx-deal-filter]').forEach(function (button) {
        var active = button.dataset.fxDealFilter === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      cards.forEach(function (card) { card.hidden = value !== 'all' && card.dataset.fxDealCategory !== value; });
    };
    document.querySelectorAll('[data-fx-deal-filter]').forEach(function (button) {
      button.addEventListener('click', function () { sync(button.dataset.fxDealFilter); });
    });
    sync('all');
  }

  function initSpcScrollHeader() {
    var intro = document.querySelector('.fx-spc-collection-intro');
    var bar = document.querySelector('[data-fx-spc-scroll-header]');
    var sourceFilter = document.querySelector('[data-fx-collection-sheen]');
    if (!intro || !bar || bar.dataset.fxSpcScrollReady) return;
    bar.dataset.fxSpcScrollReady = 'true';
    document.body.classList.add('fx-spc-scroll-header-page');

    var stickyButtons = bar.querySelectorAll('[data-fx-spc-sticky-filter]');
    var header = document.querySelector('#shopify-section-header');
    var headerOffset = 0;
    var updateHeaderOffset = function () {
      headerOffset = window.matchMedia('(max-width: 767px)').matches ? 0 : (header ? Math.round(header.getBoundingClientRect().height) : 0);
      document.documentElement.style.setProperty('--fx-spc-header-offset', headerOffset + 'px');
    };
    updateHeaderOffset();
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateHeaderOffset).observe(header);
    var syncSheen = function (value) {
      stickyButtons.forEach(function (button) {
        var active = button.dataset.fxSpcStickyFilter === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };
    if (sourceFilter) {
      syncSheen((sourceFilter.querySelector('.is-active') || {}).dataset ? (sourceFilter.querySelector('.is-active').dataset.fxSheenFilter || 'all') : 'all');
      document.addEventListener('fx:collection-sheen-change', function (event) { syncSheen(event.detail.value); });
    }
    stickyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var sourceButton = sourceFilter && sourceFilter.querySelector('[data-fx-sheen-filter="' + button.dataset.fxSpcStickyFilter + '"]');
        if (sourceButton) sourceButton.click();
      });
    });
    bar.querySelector('[data-fx-spc-back-to-top]').addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });

    var mobileTitle = intro.querySelector('.fx-spc-collection-intro__eyebrow');
    var mobileTitleSlot = bar.querySelector('[data-fx-spc-sticky-title-slot]');
    var mobileBurger = document.querySelector('.menu_moblie .menuleft');
    var mobileBurgerSlot = bar.querySelector('[data-fx-spc-mobile-burger]');
    var mobileTitlePlaceholder;
    var mobileBurgerPlaceholder;
    var mobileHandoff = false;
    var moveWithFlip = function (element, slot, placeholderName, movingName) {
      if (!element || !slot || element.parentElement === slot) return null;
      var first = element.getBoundingClientRect();
      var placeholder;
      if (movingName === 'data-fx-spc-title-moving') {
        var titleStyle = window.getComputedStyle(element);
        placeholder = document.createElement('span');
        placeholder.className = 'fx-spc-title-handoff-placeholder';
        placeholder.style.cssText = 'display:block;height:' + first.height + 'px;margin-top:' + titleStyle.marginTop + ';margin-bottom:' + titleStyle.marginBottom + ';';
      } else {
        placeholder = document.createComment(placeholderName);
      }
      element.parentNode.insertBefore(placeholder, element);
      slot.appendChild(element);
      element.setAttribute(movingName, 'true');
      var last = element.getBoundingClientRect();
      var x = first.left - last.left;
      var y = first.top - last.top;
      var scaleX = last.width ? first.width / last.width : 1;
      var scaleY = last.height ? first.height / last.height : 1;
      element.style.transition = 'none';
      element.style.transformOrigin = 'top left';
      element.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + scaleX + ',' + scaleY + ')';
      element.offsetWidth;
      requestAnimationFrame(function () {
        element.style.transition = 'transform .46s cubic-bezier(.22,.61,.36,1)';
        element.style.transform = '';
        window.setTimeout(function () {
          if (element.parentElement === slot) element.style.transition = '';
        }, 480);
      });
      return placeholder;
    };
    var restoreMovedElement = function (element, placeholder, movingName) {
      if (element && placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(element, placeholder);
        placeholder.parentNode.removeChild(placeholder);
      }
      if (element) {
        element.style.transition = '';
        element.style.transform = '';
        element.style.transformOrigin = '';
        element.removeAttribute(movingName);
      }
    };
    var beginMobileHandoff = function () {
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      if (!document.body.classList.contains('fx-spc-scroll-header-active')) bar.classList.add('is-mobile-handoff');
      if (!mobileTitlePlaceholder) mobileTitlePlaceholder = moveWithFlip(mobileTitle, mobileTitleSlot, 'fx-spc-mobile-title', 'data-fx-spc-title-moving');
      if (!mobileBurgerPlaceholder) mobileBurgerPlaceholder = moveWithFlip(mobileBurger, mobileBurgerSlot, 'fx-spc-mobile-burger', 'data-fx-spc-burger-moving');
    };
    var endMobileHandoff = function () {
      restoreMovedElement(mobileTitle, mobileTitlePlaceholder, 'data-fx-spc-title-moving');
      restoreMovedElement(mobileBurger, mobileBurgerPlaceholder, 'data-fx-spc-burger-moving');
      mobileTitlePlaceholder = null;
      mobileBurgerPlaceholder = null;
      bar.classList.remove('is-mobile-handoff');
    };

    var setActive = function (active) {
      document.body.classList.toggle('fx-spc-scroll-header-active', active);
      bar.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active || mobileHandoff) beginMobileHandoff();
      if (active) bar.classList.remove('is-mobile-handoff');
      if (!active && !mobileHandoff) endMobileHandoff();
    };
    var mobileQuery = window.matchMedia('(max-width: 767px)');
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', function () {
      if (mobileQuery.matches && (mobileHandoff || document.body.classList.contains('fx-spc-scroll-header-active'))) beginMobileHandoff();
      else endMobileHandoff();
    });
    if ('IntersectionObserver' in window) {
      var handoffThreshold = mobileQuery.matches ? 0.84 : 0.68;
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setActive(!entry.isIntersecting);
      }, { threshold: 0, rootMargin: '-' + (headerOffset + 20) + 'px 0px 0px 0px' }).observe(intro);
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        mobileHandoff = !entry.isIntersecting || entry.intersectionRatio < handoffThreshold;
        document.body.classList.toggle('fx-spc-scroll-header-handoff', mobileHandoff);
        if (mobileHandoff) beginMobileHandoff();
        else if (!document.body.classList.contains('fx-spc-scroll-header-active')) endMobileHandoff();
      }, { threshold: [0, handoffThreshold], rootMargin: '-' + (headerOffset + 20) + 'px 0px 0px 0px' }).observe(intro);
    }
  }

  function initSpcCardPriceRelay() {
    if (!window.matchMedia('(min-width: 768px)').matches) return;
    var cards = Array.from(document.querySelectorAll('.product-item-v9')).filter(function (card) {
      return card.querySelector('.fx-spc-card-scroll-meta') && card.querySelector('.fx-spc-card-heading') && card.querySelector('.img-product');
    });
    if (!cards.length) return;
    var ticking = false;
    var update = function () {
      ticking = false;
      var header = document.querySelector('#shopify-section-header');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      cards.forEach(function (card) {
        var heading = card.querySelector('.fx-spc-card-heading').getBoundingClientRect();
        var image = card.querySelector('.img-product').getBoundingClientRect();
        var fading = heading.bottom < headerBottom + 34;
        var active = heading.bottom < headerBottom - 10 && image.bottom > headerBottom + 72 && image.top < window.innerHeight - 24;
        card.classList.toggle('fx-spc-card-handoff-fading', fading);
        card.classList.toggle('fx-spc-card-price-relay-active', active);
      });
    };
    var schedule = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
  }

  function normalizeCollectionTitleDashes() {
    document.querySelectorAll('.collection-page-sidebar .product-item-v9 .title-product a, .collection-page-sidebar .fx-spc-card-scroll-meta__title').forEach(function (element) {
      if (element.dataset.fxStraightDashReady) return;
      var title = element.textContent;
      if (!/[\-–—]/.test(title)) return;
      element.dataset.fxStraightDashReady = 'true';
      element.textContent = '';
      title.split(/([\-–—])/).forEach(function (part) {
        if (/^[\-–—]$/.test(part)) {
          var dash = document.createElement('span');
          dash.className = 'fx-title-straight-dash';
          dash.textContent = '-';
          element.appendChild(dash);
        } else {
          element.appendChild(document.createTextNode(part));
        }
      });
    });
  }

  function initGenericCollectionScrollHeaders() {
    document.querySelectorAll('[data-fx-generic-scroll-header]').forEach(function (bar) {
      if (bar.dataset.fxGenericScrollReady) return;
      bar.dataset.fxGenericScrollReady = 'true';
      var header = document.querySelector('#shopify-section-header');
      var isDeals = bar.classList.contains('fx-deals-scroll-header');
      var dealsIntro = isDeals ? document.querySelector('.fx-deals-intro') : null;
      var trigger = dealsIntro || document.querySelector('.collection-page-sidebar .content-page') || document.querySelector('.collection-page-sidebar');
      if (!trigger) return;
      document.body.classList.add('fx-spc-scroll-header-page');
      var updateHeaderOffset = function () {
        var offset = window.matchMedia('(max-width: 767px)').matches ? 0 : (header ? Math.round(header.getBoundingClientRect().height) : 0);
        document.documentElement.style.setProperty('--fx-spc-header-offset', offset + 'px');
      };
      var setActive = function (active) {
        document.body.classList.toggle('fx-spc-scroll-header-active', active);
        if (bar.classList.contains('fx-all-panels-scroll-header')) {
          if (active) {
            bar.style.setProperty('opacity', '1', 'important');
            bar.style.setProperty('pointer-events', 'auto', 'important');
            bar.style.setProperty('transform', 'translateY(0)', 'important');
          } else {
            bar.style.removeProperty('opacity');
            bar.style.removeProperty('pointer-events');
            bar.style.removeProperty('transform');
          }
        }
        bar.setAttribute('aria-hidden', active ? 'false' : 'true');
      };
      var updateStickyState = function () {
        setActive(window.scrollY > 260);
      };
      updateHeaderOffset();
      if (header && 'ResizeObserver' in window) new ResizeObserver(updateHeaderOffset).observe(header);
      bar.querySelector('[data-fx-generic-back-to-top]').addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      if (isDeals && dealsIntro && 'IntersectionObserver' in window) {
        var mobileQuery = window.matchMedia('(max-width: 767px)');
        var handoffThreshold = mobileQuery.matches ? 0.84 : 0.68;
        new IntersectionObserver(function (entries) {
          setActive(!entries[0].isIntersecting);
        }, { threshold: 0, rootMargin: '-' + ((mobileQuery.matches ? 0 : (header ? Math.round(header.getBoundingClientRect().height) : 0)) + 20) + 'px 0px 0px 0px' }).observe(dealsIntro);
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          document.body.classList.toggle('fx-spc-scroll-header-handoff', !entry.isIntersecting || entry.intersectionRatio < handoffThreshold);
        }, { threshold: [0, handoffThreshold], rootMargin: '-' + ((mobileQuery.matches ? 0 : (header ? Math.round(header.getBoundingClientRect().height) : 0)) + 20) + 'px 0px 0px 0px' }).observe(dealsIntro);
        return;
      }
      window.addEventListener('scroll', updateStickyState, { passive: true });
      updateStickyState();
    });
  }

  function init() {
    initCollectionSheenFilter();
    initCollectionAttributeFilters();
    initMixedCollectionFilters();
    initAllPanelsFilters();
    initAccessoriesFilters();
    initDealsFilters();
    initSpcScrollHeader();
    initSpcCardPriceRelay();
    normalizeCollectionTitleDashes();
    initGenericCollectionScrollHeaders();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
